<app-stepper-transaction-states [beforepath]="beforepath" [beforepathCreate]="beforepathCreate"></app-stepper-transaction-states>
    <mat-divider></mat-divider>
<app-state-chat [beforepath]="beforepath" [beforepathCreate]="beforepathCreate"></app-state-chat>
